import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import TrackingStepper from './TrackingStepper';
import { useTrackingContainerStyles } from './styles';

const TrackingContainer = ({ ...props }) => {
  const { handleTracking, history, failed, mobile } = props;
  const classes = useTrackingContainerStyles();
  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
      marginTop={mobile ? '30px' : ''}
    >
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        boxSizing="border-box"
      >
        {!mobile && (
          <React.Fragment>
            <Typography variant="h2">Seguimiento de compra</Typography>
            <div
              className={classes.closeButton}
              onClick={() => handleTracking()}
            >
              &times;
            </div>
          </React.Fragment>
        )}
      </Box>
      <TrackingStepper history={history} mobile={mobile} failed={failed} />
    </Box>
  );
};

TrackingContainer.propTypes = {
  handleTracking: PropTypes.func,
  history: PropTypes.array,
  failed: PropTypes.bool,
  mobile: PropTypes.bool,
};

export default TrackingContainer;
